import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Editor from '@monaco-editor/react';
import { Link } from 'react-router-dom';

const Contentarea = ({ selectedContent }) => {
  const { subtopic_name, description, code, output, language_runner,video_link } = selectedContent || {};

  const copyCodeToClipboard = () => {
    if (code) {
      navigator.clipboard
        .writeText(code)
        .then(() => {
          toast.success('Code copied to clipboard', {
            position: 'top-right',
          });
        })
        .catch((error) => {
          console.error('Unable to copy code: ', error);
          toast.error('Failed to copy code. Please try again.', {
            position: 'top-right',
          });
        });
    }
  };

  const embedVideoLink = video_link?.includes('watch?v=')
  ? video_link.replace('watch?v=', 'embed/')
  : video_link;


  // Determine language for the editor — assuming HTML if contains <html> tag
  const isHTML = code?.includes('<html') || code?.includes('<!DOCTYPE html>');
  const editorLanguage = isHTML ? 'html' : 'javascript';

  return (
    <div>
      <ToastContainer />
      {selectedContent ? (
        <div>
          <h4 className='programname'>{subtopic_name}</h4>
          <div dangerouslySetInnerHTML={{ __html: description }} style={{ padding: '7px' }} />
          
          {code && (
            <div className='codeEditor'>
              <div className='chead'>
                <h6>Code</h6>
                {language_runner && (
                  <button className='copy_button'>
                    <Link to={language_runner}>Try Yourself</Link>
                  </button>
                )}
                <button className='copy_button' onClick={copyCodeToClipboard}>
                  COPY
                </button>
              </div>
              <Editor
                theme='vs-dark'
                height='60vh'
                defaultLanguage={editorLanguage}
                value={code}
                options={{ readOnly: true }}
              />
            </div>
          )}

          {/* HTML Preview */}
          {isHTML && code && (
            <div className='codeEditor' style={{ marginTop: '20px' }}>
              <div className='chead'>
                <h6>Live HTML Preview</h6>
              </div>
              <iframe
                title="HTML Preview"
                srcDoc={code}
                sandbox="allow-scripts allow-same-origin"
                style={{ width: '100%', height: '400px', border: '1px solid #ccc', background: '#fff' }}
              />
            </div>
          )}

          <br />
          {output && (
            <div className='codeEditor'>
              <div className='chead'>
                <h6>Output</h6>
              </div>
              <p className='codeBgc'>
                <div dangerouslySetInnerHTML={{ __html: output }} />
              </p>
            </div>
          )}
        </div>
      ) : (
        <p>No content available</p>
      )}
      {console.log("This is a video",video_link)}
      {/* <iframe style={{ marginTop: '5px' }} width="100%" height="auto" src={video_link} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
   <iframe
  style={{ marginTop: '5px' }}
  width="100%"
  height="400px"
  src={embedVideoLink}
  title="YouTube video player"
  frameBorder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
  referrerPolicy="strict-origin-when-cross-origin"
  allowFullScreen
/>

   
    </div>
  );
};

export default Contentarea;





// import React from 'react';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Editor from '@monaco-editor/react';
// import { Link } from 'react-router-dom';

// const Contentarea = ({ selectedContent }) => {
//   const { subtopic_name, description, code, output, language_runner } = selectedContent || {};

//   const copyCodeToClipboard = () => {
//     if (code) {
//       navigator.clipboard
//         .writeText(code)
//         .then(() => {
//           toast.success('Code copied to clipboard', {
//             position: 'top-right',
//           });
//         })
//         .catch((error) => {
//           console.error('Unable to copy code: ', error);
//           toast.error('Failed to copy code. Please try again.', {
//             position: 'top-right',
//           });
//         });
//     }
//   };

//   // Determine language for the editor — assuming HTML if contains <html> tag
//   const isHTML = code?.includes('<html') || code?.includes('<!DOCTYPE html>');
//   const editorLanguage = isHTML ? 'html' : 'javascript';

//   return (
//     <div>
//       <ToastContainer />
//       {selectedContent ? (
//         <div>
//           <h4 className='programname'>{subtopic_name}</h4>
//           <div dangerouslySetInnerHTML={{ __html: description }} style={{ padding: '7px' }} />
          
//           {code && (
//             <div className='codeEditor'>
//               <div className='chead'>
//                 <h6>Code</h6>
//                 {language_runner && (
//                   <button className='copy_button'>
//                     <Link to={language_runner}>Try Yourself</Link>
//                   </button>
//                 )}
//                 <button className='copy_button' onClick={copyCodeToClipboard}>
//                   COPY
//                 </button>
//               </div>
//               <Editor
//                 theme='vs-dark'
//                 height='60vh'
//                 defaultLanguage={editorLanguage}
//                 value={code}
//                 options={{ readOnly: true }}
//               />
//             </div>
//           )}

//           {/* HTML Preview */}
//           {isHTML && code && (
//             <div className='codeEditor' style={{ marginTop: '20px' }}>
//               <div className='chead'>
//                 <h6>Live HTML Preview</h6>
//               </div>
//               <iframe
//                 title="HTML Preview"
//                 srcDoc={code}
//                 sandbox="allow-scripts allow-same-origin"
//                 style={{ width: '100%', height: '400px', border: '1px solid #ccc', background: '#fff' }}
//               />
//             </div>
//           )}

//           <br />
//           {output && (
//             <div className='codeEditor'>
//               <div className='chead'>
//                 <h6>Output</h6>
//               </div>
//               <p className='codeBgc'>
//                 <div dangerouslySetInnerHTML={{ __html: output }} />
//               </p>
//             </div>
//           )}
//         </div>
//       ) : (
//         <p>No content available</p>
//       )}
//     </div>
//   );
// };

// export default Contentarea;
